import { render, staticRenderFns } from "./SwatchSelect.vue?vue&type=template&id=a2829b3c&scoped=true&"
import script from "./SwatchSelect.vue?vue&type=script&lang=js&"
export * from "./SwatchSelect.vue?vue&type=script&lang=js&"
import style0 from "./SwatchSelect.vue?vue&type=style&index=0&id=a2829b3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2829b3c",
  null
  
)

export default component.exports